import Highcharts from 'highcharts';

export const figure3 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        backgroundColor:'rgba(255, 255, 255, 0.0)',
        marginTop: 50,
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    colors: ['#4c5d6a', '#ed7d31'],
    exporting: {
        enabled: false
    },
    xAxis: [{
        categories: ['2005','2006','2007','2008','2009','2010','2011','2012','2013','2014','2015','2016','2017','2018','2019','2020*'],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],
    yAxis: [{ // Primary yAxis
        labels: {
            format: '{value}%',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        // lineColor: "#5b9bd5",
        // tickColor: "#5b9bd5",
        offset: 10,
        gridLineWidth: 0,
        max: 19,
        min: 5,
        tickInterval: 2,
        startOnTick: false,
        endOnTick: false,
        title: {
            text: null,
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }, { // Secondary yAxis
        title: {
            text: null,
            style: {
                color: Highcharts.getOptions().colors[0]
            }
        },
        max: 1000,
        min: 0,
        tickInterval: 100,
        startOnTick: false,
        endOnTick: false,
        // plotLines: [{
        //     color: '#d7d7d7',
        //     width: 1,
        //     value: 1000
        // }],
        offset: 10,
        gridLineWidth: 0,
        labels: {
            format: '{value} M',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
        opposite: true
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        // formatter: function() {
        //     console.log(this)
        // },
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                //enabled: false,
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [{
        name: 'Número de personas subalimentadas (millones, eje derecho)',
        id: "number",
        type: 'line',
        yAxis: 1,
        color: '#4c5d6a',
        
        zoneAxis: 'x',
        zones: [{
            value: 14
        }, {
            dashStyle: 'dot'
        }],

        dataLabels: {
            enabled: false,
            formatter: function () {
                return this.y.toFixed(1);
            },
            style: {
                fontWeight: 'normal',
                color: '#999999',
                textOutline: false,
                fontSize: '12px'
            }

        },

        data: [
          { y: 810.7, dataLabels: {enabled:true} },
          764.9,
          711.3,
          685.5,
          684.4,
          636.8,
          635.8,
          637.4,
          631.2,
          { y: 606.9, dataLabels: {enabled:true} },
          { y: 615.1, dataLabels: {enabled:true} },
          619.6,
          615.0,
          633.4,
          { y: 650.3, dataLabels: {enabled:true} },
          {
            y: 768.0,
            dataLabels: {enabled:true},
            marker: {
                fillColor: '#ffffff',
                lineColor:'#4c5d6a',
                
                lineWidth: 2
            },
          }
        ],
        tooltip: {
            valueSuffix: 'Millones'
        }
        

    }, {
        name: 'Número de personas subalimentadas',
        type: 'arearange',
        color: '#4c5d6a',
        lineWidth: 0,
        linkedTo: ':previous',
        fillOpacity: 0.3,
        zIndex: 0,
        yAxis: 1,
        
        zoneAxis: 'x',
        marker: {
            enabled: false
        },
        data: [
            {
                x: 14,
                low: 650.3,
                high: 650.3,
                name: "Point1",
            },
            {
                x: 15,
                low: 811,
                high: 720.4,
                name: "Point2",
                dataLabels: {
                    enabled:true, 
                    allowOverlap:true, 
                    className:'arearange-value',
                    padding:5,
                    // eslint-disable-next-line
                    enabled: true,
                    formatter: function () {
                        return this.y;
                    },
                    style: {
                        fontWeight: 'normal',
                        textOutline: false,
                        color: '#999999',
                        fontSize: '12px'
                    }

                }
            },
        ],
        tooltip: {
            valueSuffix: 'M'
        },
        
    }, {
        name: 'Prevalencia de la subalimentación (porcentaje, eje izquierdo)',
        id: "prev",
        type: 'line',
        color: '#ed7d31',
        
        zoneAxis: 'x',
        zones: [{
            value: 14
        }, {
            dashStyle: 'dot'
        }],
        dataLabels: {
            enabled: false,
            formatter: function () {
                return this.y.toFixed(1)+"%";
            },
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }
        },
        data: [
          { y: 12.4, dataLabels: {enabled:true} },
          11.5, 
          10.6, 
          10.1, 
          10.0,
          9.2,
          9.0,
          8.9,
          8.8,
          { y: 8.3, dataLabels: {enabled:true} },
          { y: 8.3, dataLabels: {enabled:true} },
          8.3,
          8.1,
          8.3,
          { y: 8.4, dataLabels: {enabled:true} },
            {
              y: 9.9,
              dataLabels: {
                  enabled:true, 
                //   x: 200, 
                //   y: -10
                },
              marker: {
                  fillColor: '#ffffff',
                  lineColor:'#ed7d31',
                  lineWidth: 2
                 
              },

          }
        ],
        tooltip: {
            valueSuffix: '%'
        }
    }, {
        name: 'Prevalencia de la subalimentación',
        type: 'arearange',
        color: '#ed7d31',
        lineWidth: 0,
        linkedTo: ':previous',
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
            enabled: false
        },
        data: [
            {
                x: 14,
                low: 8.4,
                high: 8.4,
                name: "Point1",
            },
            {
                x: 15,
                low: 10.4,
                high: 9.2,
                name: "Point2",
                dataLabels: {
                    enabled:true, 
                    allowOverlap:true, 
                    className:'arearange-value',
                    padding:5,
                    // verticalAlign:top
                    // useHTML:true
                    formatter: function () {
                        return this.y+"%";
                    },
                    style: {
                        fontWeight: 'normal',
                        textOutline: false,
                        color: '#999999',
                        fontSize: '12px'
                    }

                }
            },
        ],
        tooltip: {
            valueSuffix: '%'
        },
        
    }],


}
